import axios from 'axios';
import { GET_FILE_PATH } from '../../../config/realstar-api-config';

export const checkIfFileExists = async(folderName , fileName) => {
    const newFolderName = folderName.toLowerCase()
    // const newFileName = `${fileName}.pdf`
    const newFileName = `${fileName}`
  
    const fileURL = `${GET_FILE_PATH}/${newFolderName}/${newFileName}`
    // console.log( fileURL)
  try {
    // Perform a HEAD request
    const response = await axios.head(fileURL);
    
    if (response.status === 200) {
      if (response.headers['content-length'] && response.headers['content-length'] > 0) {
      

        return fileURL;
      } else {
        console.log('File may not exist, content-length is zero.');
        return false;
      }
    } else {
      // Handle other status codes if necessary
      console.log(`Received status code: ${response.status}`);
      return false;
    }
  } catch (error) {
    // Handle errors such as 404 Not Found or network issues
        if (error.response && error.response.status === 404) {
        console.log('No existing file.');
        } else {
        console.error('Error checking file existence:', error.message);
        }
    return false;
  }
}